<template>
  <v-navigation-drawer
    v-model="show"
    fixed
    temporary
    right
    class="max-height-100vh"
  >
    <v-list-item class="py-4">
      <v-avatar item :color="user.color" class="mr-4">
        <span class="white--text" v-text="user.initials"></span>
      </v-avatar>

      <v-list-item-content>
        <v-list-item-title v-text="user.name"></v-list-item-title>
        <v-list-item-subtitle v-text="domain?.name"></v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <div class="px-3">
      <v-btn
        @click="deactivateSession"
        block
        outlined
        color="primary"
      >
        <v-icon class="mr-3">mdi-account-sync</v-icon>
        Växla användare
      </v-btn>
    </div>

    <template v-slot:append>
      <div class="pa-2">
        <v-btn
          @click="showChangelog = true"
          block
          text
          color="secondary"
          class="mb-4"
        >
          <v-icon class="mr-2">mdi-alert-decagram</v-icon>
          Nyheter
        </v-btn>
        <a :href="termsUrl" target="_blank" class="text-decoration-none">
          <v-btn
            block
            text
            color="primary"
            class="mb-4"
          >
            <v-icon class="mr-2">mdi-file-sign</v-icon>
            Bokningsvillkor
          </v-btn>
        </a>
        <v-btn
          @click="checkForUpdates"
          block
          text
          color="primary"
          class="mb-4"
          :loading="isCheckingForUpdates"
        >
          <v-icon class="mr-2">mdi-refresh</v-icon>
          Uppdatera
        </v-btn>
        <v-btn
          @click="logout"
          block
          outlined
          color="error"
          :loading="isLoggingOut"
        >
          Logga ut
        </v-btn>
      </div>
    </template>

    <changelog-dialog v-model="showChangelog"></changelog-dialog>

  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'

import ChangelogDialog from '@/components/changelog/ChangelogDialog.vue'
import { checkForUpdates } from '@/registerServiceWorker'
import { snackbar } from '@/store/snackbar'

export default {
  name: 'UserNavigationDrawer',
  components: {
    ChangelogDialog
  },
  props: {
    isOpen: Boolean
  },
  data: () => ({
    isLoggingOut: false,
    showChangelog: false,
    isCheckingForUpdates: false
  }),
  computed: {
    ...mapGetters(
      {
        activeAuthSession: 'user/activeAuthSession'
      }
    ),
    user: function () {
      return this.activeAuthSession?.user
    },
    domain: function () {
      return this.activeAuthSession?.domain
    },
    termsUrl: function () {
      const namespace = this.user?.namespace
      if (!namespace) {
        return ''
      }
      return `https://${namespace}.campingonline.se/villkor`
    },
    show: {
      get: function () {
        return this.isOpen
      },
      set: function (val) {
        this.$emit('set-is-open', val)
      }
    }
  },
  methods: {
    deactivateSession: function () {
      this.$store.dispatch('user/deactivateAuthSession')
        .then(() => {
          this.show = false
        })
    },
    logout: function () {
      this.isLoggingOut = true
      this.$store.dispatch('user/logout')
        .finally(() => {
          this.isLoggingOut = false
        })
    },
    checkForUpdates: async function () {
      this.isCheckingForUpdates = true
      try {
        const result = await checkForUpdates()
        if (result.hasUpdate) {
          this.$store.commit('SET_UPDATE_SOURCE', 'service-worker')
          this.$store.commit('SET_UPDATE_TYPE', 'pwa')
          this.$store.commit('SET_SHOW_UPDATE_DIALOG', true)
        } else if (result.reason === 'error') {
          snackbar.error('Kunde inte kontrollera uppdateringar')
        } else {
          snackbar.success('Du har redan den senaste versionen')
        }
      } catch (error) {
        console.error('Fel vid sökning efter uppdateringar:', error)
        snackbar.error('Kunde inte kontrollera uppdateringar')
      } finally {
        this.isCheckingForUpdates = false
      }
    }
  }
}
</script>
